import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {
  ApiController,
  ApiExecutor,
  ApiResponse,
  ApiValidationService,
  Body,
  GET,
  PATCH,
  Params,
  PaginatedResult,
  Query,
} from '@app/core/api';

import {NotificationCustomReadDto} from './dto/notification-custom-read.dto';
import type {NotificationInfoResult, NotificationResult} from './notification-api.models';

@ApiController('api/app/notification')
@Injectable({
  providedIn: 'root',
})
export class NotificationApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @GET('/system')
  getSystemNotifications(@Query() query: Record<string, unknown>): Observable<ApiResponse<PaginatedResult<NotificationResult>>> {
    return {} as Observable<ApiResponse<PaginatedResult<NotificationResult>>>;
  }

  @GET('/system/:id')
  getSystemNotificationInfo(@Params('id') id: number): Observable<ApiResponse<NotificationInfoResult>> {
    return {} as Observable<ApiResponse<NotificationInfoResult>>;
  }

  @GET('/custom')
  getCustomNotifications(@Query() query: Record<string, unknown>): Observable<ApiResponse<PaginatedResult<NotificationResult>>> {
    return {} as Observable<ApiResponse<PaginatedResult<NotificationResult>>>;
  }

  @GET('/custom/:id')
  getCustomNotificationInfo(@Params('id') id: number): Observable<ApiResponse<NotificationInfoResult>> {
    return {} as Observable<ApiResponse<NotificationInfoResult>>;
  }

  @PATCH('/custom/read')
  markCustomNotificationsAsRead(@Body() dto: NotificationCustomReadDto): Observable<ApiResponse<unknown>> {
    return {} as Observable<ApiResponse<unknown>>;
  }
}
